import { Shield } from "lucide-react";
import { PracticeTypeData } from "@/utils/practiceTypeData";
import HeroSection from "@/components/layout/HeroSection";
import hausarztImage from "@/assets/hausarzt-practice.jpg";
import zahnarztImage from "@/assets/zahnarzt-practice.jpg";
import mvzImage from "@/assets/mvz-center.jpg";
import klinikImage from "@/assets/klinik-hospital.jpg";
import facharztImage from "@/assets/facharzt-practice.jpg";

interface PracticeTypeHeroProps {
  practiceType: PracticeTypeData;
}

const practiceImages: Record<string, string> = {
  "hausarzt": hausarztImage,
  "zahnarzt": zahnarztImage,
  "mvz": mvzImage,
  "klinik": klinikImage,
  "facharzt": facharztImage,
};

const PracticeTypeHero = ({ practiceType }: PracticeTypeHeroProps) => {
  const heroImage = practiceImages[practiceType.slug];
  
  return (
    <HeroSection
      image={heroImage}
      alt={`Cyberversicherung für ${practiceType.name}`}
      title={practiceType.heroTitle}
      gradientPreset="none"
      imageOpacity={40}
      overlayColor="background"
      className="py-20 sm:py-24 lg:py-32 px-4"
    >
      <div className="container mx-auto max-w-4xl text-center relative z-10">
        <div className="inline-flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 bg-accent/10 rounded-full mb-6">
          <Shield className="w-5 h-5 sm:w-6 sm:h-6 lg:w-7 lg:h-7 text-accent" />
        </div>
        
        <h1 className="text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-6">
          {practiceType.heroTitle}
        </h1>
        
        <div className="space-y-6 mb-6">
          <p className="text-base sm:text-lg lg:text-xl text-foreground max-w-2xl mx-auto font-semibold">
            {practiceType.heroSubtitle}
          </p>
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/20 border border-accent/40 rounded-full">
            <Shield className="w-4 h-4 text-accent" />
            <span className="text-accent font-semibold text-sm">
              {practiceType.practiceCount} {practiceType.name} in Deutschland
            </span>
          </div>
        </div>
      </div>
    </HeroSection>
  );
};

export default PracticeTypeHero;
